<template>
  <div>
    <div id="debug" @click="toggleDebug"/>
    <div id="debug-menu" :class="{ visible: debugMode }">
      <div class="lang">
        <div @click="switchLang('fr')">FR</div>
        <div @click="switchLang('en')">EN</div>
      </div>
    </div>
    <router-view/>
    <SpEmbedVideoPopup/>
    <Notification/>
    <JobModalStore/>
    <JobActionsStore/>
  </div>
</template>

<script>
  /* ============
   * Entry Point
   * ============
   *
   * The entry point of the application
   */

import Notification from '@/components/Notification';
import JobModalStore from '@/components/Store/JobModalStore';
import JobActionsStore from '@/components/Store/JobActionsStore';
import SpEmbedVideoPopup from '@/components/SP/SPEmbedVideoPopup';
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';
import { useAuthStore } from '@/stores/auth';
import { useDebugStore } from '@/stores/debug';
import intercom from '@/plugins/intercom';
import accountService from './services/account';

export default {
  components: {
    SpEmbedVideoPopup,
    Notification,
    JobModalStore,
    JobActionsStore,
  },
  computed: {
    ...mapStores(useAccountStore, useAuthStore, useDebugStore),
    isTempAgencyMode() {
      return this.$brand.isTempAgency;
    },
    debugMode() {
      return this.dbugStore.debug;
    },
  },
  watch: {
    isTempAgencyMode: {
      immediate: true,
      handler(val) {
        document.title = `${val ? 'Talent Work' : 'Student Pop'} - Espace client`;
        const favicon = document.querySelector('link[rel="shortcut icon"]');
        favicon.href = `${val ? '/static/img/talent_work_favicon.ico' : '/static/img/favicon.ico'}?v=${Date.now()}`;
      },
    },
  },
  /**
   * Fires when the app has been mounted
   */
  mounted() {
    // If the user is authenticated,
    // fetch the data from the API
    this.authStore.setUserAgent();
    if (this.authStore.authenticated) {
      accountService.find();
    }
    intercom.boot();
  },
  methods: {
    toggleDebug() {
      this.dbugStore.open();
    },
    switchLang(lang) {
      this.$i18n.locale = lang;
    },
  },
};
</script>

<style lang="scss">
  @import 'styles/style.scss';
</style>
